import React from 'react';
import { useIsRouterChanging } from '@/hooks/useIsRouterChanging';
import styles from './RountingIndicator.module.scss';

export const RountingIndicator = () => {
  const display = useIsRouterChanging();
  return display ? (
    <div className={styles.container}>
      <div className={styles.progressBar}></div>
    </div>
  ) : null;
};
